<section class="card-topic-section__section">
  @if (title) {
    <div class="card-topic-section__section-container">
      @if (title && !isFirstSection) {
        <h2 class="card-topic-section__title" [innerHTML]="title"></h2>
      }
      @if (title && isFirstSection) {
        <h1 class="card-topic-section__title" [innerHTML]="title"></h1>
      }
    </div>
  }
  <div
    class="card-topic-section__section-container card-topic-section__container"
  >
    @for (card of contents; track card) {
      <div class="card-topic-section__card-wrapper">
        @if (card.link && card.preparedLink && !card.preparedLink.urlObject) {
          <a
            class="card-topic-section__card-link"
            [routerLink]="[card.preparedLink.url] | localize"
          >
            <app-card-topic-card [card]="card"></app-card-topic-card>
          </a>
        }
        @if (card.link && card.preparedLink && card.preparedLink.urlObject) {
          <a
            class="card-topic-section__card-link"
            [href]="card.preparedLink.url"
          >
            <app-card-topic-card [card]="card"></app-card-topic-card>
          </a>
        }
        @if (!card.link) {
          <app-card-topic-card [card]="card"></app-card-topic-card>
        }
      </div>
    }
  </div>
</section>
